import { render, staticRenderFns } from "./BannersSection.vue?vue&type=template&id=035136bc&scoped=true&"
import script from "./BannersSection.vue?vue&type=script&lang=js&"
export * from "./BannersSection.vue?vue&type=script&lang=js&"
import style0 from "./BannersSection.vue?vue&type=style&index=0&id=035136bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035136bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
